import { NetworkRequestState } from '../baseTypes';
import { BrowsingModeWidgetData } from './types';

const defaultBrowsingModeWidgetData: NonNullable<
  BrowsingModeWidgetData['initialData']
> = {
  contentFilter: 'standard',
  contentFilterList: [],
};

export const defaultBrowsingModeWidgetState: BrowsingModeWidgetData = {
  initialData: defaultBrowsingModeWidgetData,
  currentData: defaultBrowsingModeWidgetData,
  isDirty: false,
  saveRequest: {
    status: NetworkRequestState.IDLE,
  },
};
